import { render, staticRenderFns } from "./BolletteList.vue?vue&type=template&id=7d42f0ce&"
import script from "./BolletteList.vue?vue&type=script&lang=js&"
export * from "./BolletteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BolletteList.vue"
export default component.exports